export default "__VITE_ASSET__CdWHRd7e__"